import React, { createContext, useContext, useEffect, useRef } from 'react';
import { watchSignal, unwatchSignal } from '../internals/watch.js';
import { schedulePull } from '../internals/scheduling.js';
class PauseSignalsManager {
    signals = new Set();
    _paused;
    constructor(initialPaused) {
        this._paused = initialPaused;
    }
    get paused() {
        return this._paused;
    }
    register(signal) {
        this.signals.add(signal);
    }
    unregister(signal) {
        this.signals.delete(signal);
    }
    setPaused(value) {
        if (value === this._paused)
            return;
        this._paused = value;
        for (const signal of this.signals) {
            if (value) {
                unwatchSignal(signal, { isPausing: true });
            }
            else {
                watchSignal(signal);
                schedulePull(signal);
            }
        }
    }
}
const PauseSignalsManagerContext = createContext(null);
export function PauseSignalsProvider({ value, children }) {
    const managerRef = useRef(null);
    if (managerRef.current === null) {
        managerRef.current = new PauseSignalsManager(value);
    }
    const manager = managerRef.current;
    useEffect(() => {
        manager.setPaused(value);
    }, [manager, value]);
    return React.createElement(PauseSignalsManagerContext.Provider, { value: manager }, children);
}
export function usePauseSignalsManager() {
    return useContext(PauseSignalsManagerContext);
}
